export type SupervisorButtonAction =
  | 'trigger_agents'
  | 'resume_design'
  | 'run_artifact_updates'
  | 'download_code'
  | 'navigate'
  | 'open_billing'
  | 'prefill_chat'
  | 'focus_chat'
  | 'start_build'
  | 'trigger_export_proposal'
  | 'open_share_modal'
  | 'open_design_editor'
  | 'trigger_stage_deploy';

export interface SupervisorButton {
  key: string;
  kind: 'workflow' | 'agent' | 'action';
  label: string;
  doneLabel?: string;
  done_label?: string;
  action: SupervisorButtonAction;
  payload?: Record<string, unknown>;
  icon?: string | null;
  style?: 'primary' | 'secondary' | string;
  enabled?: boolean;
}

export type SupervisorResumePhase = 'user_flow' | 'first_page' | 'all_pages' | 'review_build' | 'auto';

const isSupervisorResumePhase = (phase: unknown): phase is SupervisorResumePhase => (
  phase === 'user_flow'
  || phase === 'first_page'
  || phase === 'all_pages'
  || phase === 'review_build'
  || phase === 'auto'
);

export const supervisorButtonResumePhase = (
  button?: SupervisorButton,
  fallback: unknown = 'auto',
): SupervisorResumePhase => {
  const buttonPhase = button?.payload?.phase;

  if (isSupervisorResumePhase(buttonPhase)) return buttonPhase;
  if (isSupervisorResumePhase(fallback)) return fallback;

  return 'auto';
};
